import { ActionType } from "../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../react-core/Flux/Dispatcher";
import { AccountRoleStoreStaic as AccountRoleStoreStatic } from "./AccountRoleStoreStatic";
import { ClientAccountStoreStatic } from "./AccountStoreStatic";
import { FirmLogoStoreStatic } from "./FirmLogoStoreStatic";
import { ProductDetailsStoreStatic } from "./ProductDetailsStoreStatic";
import { UserStoreStatic } from "./UserStoreStatic";
import { TreasuredAssetsStoreStatic } from "./TreasuredAssetsStoreStatic";
import { PensionSubAccountSettingsStoreStatic } from "./PensionSubAccountSettingsStoreStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const ClientAccountDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ClientAccountStore: ClientAccountStoreStatic = new ClientAccountStoreStatic();

export const ProductDetailsDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ProductDetailsStore: ProductDetailsStoreStatic = new ProductDetailsStoreStatic();

export const UserDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const UserStore: UserStoreStatic = new UserStoreStatic();

export const AccountRoleDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const AccountRoleStore: AccountRoleStoreStatic = new AccountRoleStoreStatic();

export const FirmLogoDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const FirmLogoStore: FirmLogoStoreStatic = new FirmLogoStoreStatic();

export const TreasuredAssetsDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const TreasuredAssetsStore: TreasuredAssetsStoreStatic = new TreasuredAssetsStoreStatic();

export const PensionSubAccountSettingsDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const PensionSubAccountSettingsStore: PensionSubAccountSettingsStoreStatic = new PensionSubAccountSettingsStoreStatic();